import EditIcon from "@mui/icons-material/Edit"
import { Box, IconButton } from "@mui/material"
import { useNavigate } from "react-router"
import { ProductDto } from "@custom-types/products"
import { getMaterialTableColumns } from "./const"
import { useCallback, useMemo } from "react"
import { MRT_Row } from "material-react-table"
import { Table } from "@components/Table"

interface IProductsTableProps {
  data: ProductDto[]
}

export default function ProductsTable({ data = [] }: IProductsTableProps) {
  const navigate = useNavigate()

  // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  const handleEditClick = (id: string, organisation: string, division: string) => {
    navigate(`/Administration/Products/${id}/${organisation}/${division}`)
  }

  const materialTableColumns = useMemo(
    () => getMaterialTableColumns(),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
    [getMaterialTableColumns],
  )

  const getRowActions = useCallback(
    ({ row }: { row: MRT_Row<ProductDto> }) => (
      <IconButton
        onClick={() =>
          handleEditClick(
            row.original.key,
            row.original.organisation_key,
            row.original.division_key,
          )
        }
      >
        <EditIcon />
      </IconButton>
    ),
    [handleEditClick],
  )

  return (
    <Box className={"products-table-container"}>
      <Table
        sessionStorageName={"productsTable"}
        isExportable
        enableRowActions
        columns={materialTableColumns}
        data={data}
        renderRowActions={getRowActions}
      />
    </Box>
  )
}
